export enum AddPageOptions {
  NEW_PAGE = 'newPage',
  TEMPLATE = 'template',
  DESIGN = 'design',
}

export enum PageApplyMode {
  ADD = 'add',
  REPLACE = 'replace',
  /** Timeline "+" menu: tile the pages onto the current page's timeline after the current sequence. */
  APPEND_TO_TIMELINE = 'appendToTimeline',
}
